import { render, staticRenderFns } from "./createtemplate.vue?vue&type=template&id=6530dbff&scoped=true&"
import script from "./createtemplate.vue?vue&type=script&lang=js&"
export * from "./createtemplate.vue?vue&type=script&lang=js&"
import style0 from "./createtemplate.vue?vue&type=style&index=0&id=6530dbff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530dbff",
  null
  
)

export default component.exports